export const DsInputLabelDefaultProps = {
    shrink: true
};
